import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import _ from 'lodash';

/*Dialogs*/
import AccountNumberContainers from '../../PreLogin/common/accountNumberContainers';
import PhoneNumberUpdatedOverlayDialog from '../../dialogs/phoneNumberUpdatedOverlayDialog';
import UpdateCompleteForNotificationsOverlayDialog from '../../dialogs/updateCompleteForNotificationsOverlayDialog';
import UpdateCompleteForAccountAccessRequestOverlayDialog from '../../dialogs/updateCompleteForAccountAccessRequestOverlayDialog';

/*Tabs*/
import ProfileTabs from './ProfileTabs';

import {
	saveIsAnyValidAccountNumber,
	selectAllNotificationList,
	updateNotification,
	saveUserProfile,
	updateUserAccounts,
	getAdminEmailAddress,
	dropProductSpecsEmail,
	resetGEAccountNumbers,
	sendEmailSuccessDialog,
	getUserContactPointList,
	saveUserContactPointList,
	changePhoneNumber,
	backupNotificationList,
	updateUserNotifications,
	getRoleList,
	saveRoleList,
} from '../../../redux/actions';

class MyProfile extends Component {

    constructor(props) {
        super(props);
        this.state = {
			showAddMoreAccountsLink: true,
			showUpdatePhoneNumberOverlayDialog: false,

			selectAllNotifications: false,
			showUpdatePreferencesOverlayDialog: false,
			preferencesErrorMessage: '',

			showUpdateAccountsOverlayDialog: false,
			accountsErrorMessage: '',

			phoneNumberErrorMessage: '',
			updatePhoneNumber: {
				params: {
					phoneNumber: '',
					phoneNumberDetails: null
				},
				error:{
					phoneNumberError: ''
				}
			},

			allAddresses: null,

			legacyPayload: null,

			notificationTypeListBkp: null,

			siteId: '',
			roleId: '',
			parallelCallCount: 0,

			isRoleListCallCompleted: false,
		};
		this.fetchRoleList = this.fetchRoleList.bind(this);
		this.updateNotificationInStore = this.updateNotificationInStore.bind(this);
		// this.getContactPartyId = this.getContactPartyId.bind(this);
		this.callBackAfterParallelCallsCompleted = this.callBackAfterParallelCallsCompleted.bind(this);
		this.callBackToUpdatePhoneNumber = this.callBackToUpdatePhoneNumber.bind(this);
	}

	componentWillMount() {
		const self = this,
			{ user } = self.props.state;
		if(user.userDetails.typeOfUser !== 'employee') {
			if(user.userOtherDetails) {
				if(!user.userContactPointList) {
					self.props.getUserContactPointList(`personPartyId=${user.userOtherDetails.responseObject[0].PERSON_PARTY_ID}&requestType=getUserContactPointList`, response => {
						if(response.status) {
							self.props.saveUserContactPointList(response);
							self.callBackToUpdatePhoneNumber(response);
						}
					});
				} else {
					self.callBackToUpdatePhoneNumber(user.userContactPointList);
				}
			}
			self.props.selectAllNotificationList(false);
			self.fetchRoleList();
		}
	}

	callBackToUpdatePhoneNumber(response) {
		const self = this;
		let phoneNumber = '';
		if(response.responseObject && response.responseObject.length > 0) {
			phoneNumber = _.find(response.responseObject, { 'CONTACTTYPE': 'PHONE', 'PRIMARYINDICATOR': 'Y' });
		}
		if(phoneNumber && phoneNumber.CONTACTPHONE) {
			self.setState({
				updatePhoneNumber: {
					...self.state.updatePhoneNumber,
					params: {
						...self.state.updatePhoneNumber.params,
						phoneNumber: self.normalizePhoneNumber(phoneNumber.CONTACTPHONE),
						phoneNumberDetails: phoneNumber
					}
				}
			})
		}
	}

	setValue(whichForm, fieldName, event) {
		this.setState({
			[whichForm]: {
				...this.state[whichForm],
				params: {
					...this.state[whichForm].params,
					[fieldName]: event.target.value
				},
				error: {
					...this.state[whichForm].error,
					[fieldName+"Error"]: ""
				}
			}
		})
	}

	handleAddMoreAccounts(event) {
		event.preventDefault();
		this.setState({
			showAddMoreAccountsLink: false
		});
	}

	normalizePhoneNumber(s) {
		var npa, nxx, xxxx, n;

		n = s.replace(/\D+/g, "");
		if ((/^1?([2-9]\d{2})(\d{3})(\d{4})$/).test(n)) {
			npa  = RegExp.$1;
			nxx  = RegExp.$2;
			xxxx = RegExp.$3;
			n = "(%s) %s-%s".replace(/%s/, npa).replace(/%s/, nxx).replace(/%s/, xxxx);
			return n;
		}
		return s;
	}

	isValidPhoneNumber(s) {
		if(!s) return "";
		s = s.replace(/\D+/g, "");
		return (/^1?[2-9][0-9]{9}$/).test(s);
	}

	handleUpdatePhoneNumber(event) {
		event.preventDefault();
		var self = this,
			formError = false;

		//reset messages and overlays
		self.setState({
			showUpdatePhoneNumberOverlayDialog: false,
			phoneNumberErrorMessage: ''
		});

		if(!self.isValidPhoneNumber(this.state.updatePhoneNumber.params.phoneNumber)){
			formError = true;
			self.setState({
				updatePhoneNumber:{
					...self.state.updatePhoneNumber,
					error: {
						...self.state.updatePhoneNumber.error,
						phoneNumberError: 'error'
					}
				}
			})
		}

		if(!formError) {
			const { user } = self.props.state,
				{ params } = self.state.updatePhoneNumber,
				phoneNumber = params.phoneNumber.replace("(","").replace(")","").replace(" ","").replace("-","").trim(),
				personPartyId = user.userOtherDetails.responseObject[0].PERSON_PARTY_ID;

			self.props.changePhoneNumber(`requestType=updateUserPhone&personPartyId=${personPartyId}&phone=${phoneNumber}&contactPointId=${params.phoneNumberDetails.CONTACTPOINTID}`, (response) => {
				if(response.status) {
					if(response.responseObject && response.responseObject.returnstatus) {
						if(response.responseObject.returnstatus.value === 'S') {
							//Show confirmation overlay dialog
							self.setState({
								showUpdatePhoneNumberOverlayDialog: true,
								phoneNumberErrorMessage: 'Your phone number has been successfully updated.'
							});
						} else {
							self.setState({
								showUpdatePhoneNumberOverlayDialog: false,
								phoneNumberErrorMessage: 'Unable to update phone number'
							});
						}
					}
				} else {
					browserHistory.push('/error');
				}
			});
		}
	}

	onBlurValidatePhoneNumber(event) {
		var self = this,
			updatedParams = this.state.updatePhoneNumber;

        //Reset Error flag first
    	updatedParams.error.phoneNumberError = "";

        //Update current value
		updatedParams.params.phoneNumber = event.target.value;

		if(updatedParams.params.phoneNumber !== "" && self.isValidPhoneNumber(updatedParams.params.phoneNumber)) {
			updatedParams.error.phoneNumberError = "";
			var formattedNum = self.normalizePhoneNumber(event.target.value);
			updatedParams.params.phoneNumber = formattedNum;
			event.target.value = formattedNum;
		}

        self.setState({
            updatePhoneNumber: updatedParams
        });
	}

	handleUpdateAccounts(event) {
		event.preventDefault();

		const self = this,
			{ registration } = self.props.state,
			{ geAccountNumbers } = registration;

		for (const account of geAccountNumbers) {
			if (account.accountNumber && account.accountNumber.trim() && (!(account.valid && account.isCheckedForSalesAgreements) ||
				(account.isOnlyGEAPartsSalesAgreementsAccount && !(account.userRole && account.companyName && account.companyName.trim())))) {
				return;
			}
		}

		self.setState({
			parallelCallCount: _.filter(geAccountNumbers, item => item.accountNumber).length,
		}, () => {
			if(self.state.parallelCallCount === 0) {
				// Show message to enter at least one valid account number
				self.props.saveIsAnyValidAccountNumber(false);
			}
			geAccountNumbers.forEach((item, index) => {
				if(item.accountNumber) {
					self.props.validateAccountNumber(index + 1, item.accountNumber, () => {
						const parallelCallCount = self.state.parallelCallCount;
						self.setState({
							parallelCallCount: parallelCallCount - 1,
						}, () => {
							if(self.state.parallelCallCount === 0) {
								if(!_.find(geAccountNumbers, ["valid", false]) && !_.find(geAccountNumbers, ["isAlreadyApproved", true])) {
									// reset messages and overlays
									self.setState({
										showUpdateAccountsOverlayDialog: false,
										accountsErrorMessage: ''
									});
									var accountRequests = [];
									geAccountNumbers.map((item, index) => {
										if(item.valid === true) {
											accountRequests.push({
												accountNumber: item.accountNumber,
											   	userId: self.props.state.user.userDetails.sso,
												approvalStatus: "Pending",
												accountName: item.accountName,
						                        admin: null,
												userRole: item.userRole,
												companyName: item.companyName && item.companyName.trim(),
						                        notifications: null,
						                        responsibilities: null,
						                        createdDate: null,
						                        updatedDate: null
											});
										}
										return null;
									});

									let { state } = this.props;
									//After hiding make service call of registration
									self.props.updateUserAccounts(accountRequests, 'requestType=updateAccounts', response => {
										if(response.status) {
											var accountsList = [];
											accountRequests.map((item, index) => {
												if (!item.userRole) {
													accountsList.push(item.accountNumber);
												}
												return null;
											});

											if (accountsList.length) {
												let { userDetails } = state.user;
												self.props.getAdminEmailAddress(`requestType=getAdminsOfAccounts&accountNumbers=${accountsList.join(",")}`, response => {
													const payload = {
														userName: userDetails.firstName + " " + userDetails.lastName,
														userId: userDetails.sso,
														userEmail: userDetails.email,
														adminDetails: response.responseObject,
														status:"Pending"
													};
													self.props.dropProductSpecsEmail(payload, "emailType=Registration", response => {
														self.props.sendEmailSuccessDialog(false);
														if(response.status) {
															//Show confirmation overlay dialog
															self.setState({
																showUpdateAccountsOverlayDialog: true,
																accountsErrorMessage: (!response.status)?response.responseMessage:''
															});
															self.props.resetGEAccountNumbers();
														} else {
															browserHistory.push("/error");
														}
													});
												});
											} else {
												self.setState({
													showUpdateAccountsOverlayDialog: true,
													accountsErrorMessage: ''
												});
												self.props.resetGEAccountNumbers();
											}
										} else {
											browserHistory.push("/error");
										}
									});
								} else {
									// Show message to enter at least one valid account number
									self.props.saveIsAnyValidAccountNumber(false);
								}
							}
						})
					});
				}
			});
		});
	}

	handleChangeNotificationType(event) {
		this.setState({
			preferencesErrorMessage: ''
		})
		this.props.updateNotification([{notificationType: event.target.value, bool: event.target.checked}]);
	}

	handleSelectAllNotification(flag, event){
		event.preventDefault();
		const self = this;
		self.setState({
			selectAllNotifications: flag
		}, () => {
			self.props.selectAllNotificationList(self.state.selectAllNotifications);
		});
	}

	fetchRoleList() {
		const self = this;
		const { selectedAccount, userOtherDetails, roleList } = self.props.state.user,
			soldToAddresses = self.props.getAddressesByCategory('SOLD_TO');

		let	siteId = '';
		if(soldToAddresses.length > 0) {
			siteId = soldToAddresses[0].SITEID;
		}

		self.setState({
			siteId
		});

		if(!roleList) {
			// get role list
			const personPartyId = userOtherDetails && userOtherDetails.responseObject && userOtherDetails.responseObject[0].PERSON_PARTY_ID,
				payload = `requestType=getRoleList&personPartyId=${personPartyId}&accountNumber=${selectedAccount.ACCOUNTNUMBER}`;
			self.props.getRoleList(payload, response => {
				if(response.status) {
					self.updateNotificationInStore(response);
				} else {
					browserHistory.push('/error');
				}
			});
		} else {
			self.updateNotificationInStore(roleList);
		}
	}

	updateNotificationInStore(roleList) {
		const self = this;
		const updatedNotifications = [];
		const maxRoleIdRecord = _.maxBy(roleList.responseObject, 'ROLEID');
		const roleId = maxRoleIdRecord && maxRoleIdRecord.ROLEID;

		roleList.responseObject = roleList.responseObject.filter(itm => itm.ROLEID === roleId);
		self.props.state.user.notificationTypeList.forEach(itm => {
			const data = roleList.responseObject.filter(it => it.ROLENAME === itm.shortValue);
			if(data.length > 0) {
				updatedNotifications.push({
					notificationType: itm.value,
					bool: true,
				});
			} else {
				updatedNotifications.push({
					notificationType: itm.value,
					bool: false,
				});
			}
		});
		self.props.updateNotification(updatedNotifications);
		// Backup notificationList to compare later on
		self.props.backupNotificationList();
		self.setState({
			isRoleListCallCompleted: true,
			roleId
		});
	}

	handleUpdateNotifications(event) {
		event.preventDefault();
		const updatedNotifications = [],
			self = this;
		const {
			notificationTypeListBkp,
			notificationTypeList,
			unCheckNotificationMapping,
			roleList
		} = self.props.state.user;
		let anyChangeMade = false;
		const isPricingAccess = this.props.isResponsibilityExists("Price");
		notificationTypeListBkp.forEach((item, index) => {
			if(item.checked !== notificationTypeList[index].checked) {
				anyChangeMade = true;
				// Need to pass only changed values in payload
				const mappingData = unCheckNotificationMapping.find(itm => itm.notification === item.shortValue);

				const checked = notificationTypeList[index].checked;
				let responsibilityId = '';
				const data = roleList.responseObject.find(it => (it.ROLENAME === mappingData.value || it.ROLENAME === mappingData.notification));
				if(data) {
					responsibilityId = data.RESPONSIBILITYID;
				}
				let notification = mappingData.notification;
				if(isPricingAccess && notification === "ORDER ACKNOWLEDGEMENT WO PRICE") {
					notification = "ORDER ACKNOWLEDGEMENT W PRICE";
				}
				updatedNotifications.push({
					name: checked ? notification : mappingData.value,
					selected: checked ? "Y" : "N",
					responsibilityId,
				});
			}
		})

		if(!anyChangeMade) {
			//reset messages and overlays
			self.setState({
				preferencesErrorMessage: 'Change your preferences to update'
			});
			return;
		}

		//reset messages and overlays
		self.setState({
			showUpdatePreferencesOverlayDialog: false,
			preferencesErrorMessage: '',
			updatedNotifications,
		}, () => {
			// self.getContactPartyId();
			self.callBackAfterParallelCallsCompleted();
		});
	}

	callBackAfterParallelCallsCompleted() {
		const self = this;
		const {
			isRoleListCallCompleted
		} = self.state;
		if(isRoleListCallCompleted) {
			self.props.updateUserNotifications(self.state.updatedNotifications, `requestType=updateUserNotifications&roleId=${self.state.roleId}`, response => {
				if(response.status) {
					// response.responseObject = response.responseObject && response.responseObject.filter(itm => itm.selected === "Y");
					const errorOccured = !response.responseObject || (response.responseObject && _.find(response.responseObject, ['updateSuccessful', false]))?true:false
					if(!errorOccured) {
						// Manipulate store with latest role list id and data so that no need to make get role list required again
						let roleList = JSON.parse(JSON.stringify(self.props.state.user.roleList));
						const {
							unCheckNotificationMapping
						} = self.props.state.user;
						response.responseObject.forEach(itm => {
							// if item is selected
							if(itm.selected === 'Y') {
								const mappingData = unCheckNotificationMapping.find(role => role.notification === itm.name);
								// Check if already dummy mapping is there or not
								const index = _.findIndex(roleList.responseObject, role => role.ROLENAME === mappingData.value);
								if(index !== -1) {
									roleList.responseObject[index].ROLENAME = itm.name;
								} else {
									roleList.responseObject.push({
										RESPONSIBILITYID: itm.responsibilityId,
										ROLEID: roleList.responseObject.length > 0 && roleList.responseObject[0].ROLEID,
										ROLENAME: itm.name,
										STATUS: "A"
									});
								}
							} else { // else if item is deselected
								const mappingData = unCheckNotificationMapping.find(role => role.value === itm.name);
								// Check if already original entry there or not
								const index = _.findIndex(roleList.responseObject, role => role.ROLENAME === mappingData.notification);
								if(index !== -1) {
									roleList.responseObject[index].ROLENAME = itm.name;
								}
							}
						});
						self.props.saveRoleList(roleList);

						self.setState({
							showUpdatePreferencesOverlayDialog: true,
							preferencesErrorMessage: ''
						});

						self.props.backupNotificationList();
					} else {
						self.setState({
							showUpdatePreferencesOverlayDialog: false,
							preferencesErrorMessage: 'Update notification was not successful'
						});
					}
				} else {
					browserHistory.push('/error')
				}
			});
		}
	}

    render() {
		const { user } = this.props.state;
		const { approvedAccounts, userDetails, localUserDetails, isDpmAccount }  = user;
		const isDpmCustomerWithPrepayment = isDpmAccount && userDetails.typeOfUser === 'customer' && user.selectedAccount.PAYMENTTERMS === 'Prepayment';
		const applicationUrl = window.location.host;
		const isPricingAccess = this.props.isResponsibilityExists("Price");
		const isCreateOrderAccess = this.props.isResponsibilityExists("Create Order");
		const isEditOrderAccess = this.props.isResponsibilityExists("Edit Orders");
		const isPriceDiscountAccess = this.props.isResponsibilityExists("Price Discounts");
		const isViewOrderAccess = this.props.isResponsibilityExists("View Order");
		const isThisAccountRestricted = this.props.isThisAccountRestricted;
		const typeOfAccount = this.props.getSelectedAccountType();
		
		const updatePhoneNumberNode = <div className="largePush">
				<h3>The phone number below is tied to your profile.</h3>
				<hr />
				<p className="red bold">{!this.state.showUpdatePhoneNumberOverlayDialog && this.state.phoneNumberErrorMessage}</p>
				<form onSubmit={this.handleUpdatePhoneNumber.bind(this)} className="updatePhoneNumberForm" name="updatePhoneNumberForm" id="updatePhoneNumberForm">
					{this.state.updatePhoneNumber.error.phoneNumberError === "error"
						?<div className="errorMessageContainer show">Please enter a valid phone number.</div>
						:null
					}
					<input
					value={this.state.updatePhoneNumber.params.phoneNumber}
					onBlur={this.onBlurValidatePhoneNumber.bind(this)}
					className={"phoneNumber "+this.state.updatePhoneNumber.error.phoneNumberError}
					onChange={this.setValue.bind(this, 'updatePhoneNumber', 'phoneNumber')}
					type="text"
					size={17}
					maxLength={17}
					/>
					&nbsp;
					<input type="submit" className="blueButton" value="Update Phone" />
				</form>
			</div>;

        return (
			<div>
				<ProfileTabs isEmployeeHasAccessTo={this.props.isEmployeeHasAccessTo} selectedTab='myProfile' />
				{approvedAccounts && userDetails && userDetails.typeOfUser === "customer"?
					<div className="columns twoColumns">
			        	<div className={"column noInnerTopMargin"}>
							<div className={isDpmCustomerWithPrepayment ? 'smallPush' : `largePush`}>
								<p>
									<strong>User Name:</strong> {userDetails.sso}<br />
									<strong>Email:</strong> {userDetails.email}
								</p>
								<p>
									{userDetails.typeOfUser === "customer"
										?<a className="bold" target="_blank" href={"https://b2b.geappliances.com/pwm/private/login"}>Edit Password</a>
										:<a className="bold" target="_blank" href={"https://ssopassword.geappliances.com/login?forwardURL=http://"+applicationUrl}>Edit Password</a>
									}
								</p>
							</div>
							{isDpmCustomerWithPrepayment &&<div style={{marginTop: '2rem'}}>
								<a className="orangeButton" href="https://na4-onlineapp.dnbi.com/createApp/GE+Appliances?token=jcFmxhd9TYmBtUFGg9acnA%3D%3D" target="_blank">Request Line of Credit</a>
							</div>}
				          	{!isDpmCustomerWithPrepayment && updatePhoneNumberNode}
			          		<div className="largePush">
			            		{isDpmCustomerWithPrepayment ?
											<p style={{color: '#092c74'}}><strong>Please see GE Appliances Account numbers below, please copy the corresponding account number for use when completing your D&B Credit Application for a specific property.</strong></p> :
											<h3>The following account numbers are tied to your User ID.</h3>}
			            		<hr />
								<table>
									<tbody>
										{approvedAccounts.responseObject && approvedAccounts.responseObject && approvedAccounts.responseObject.slice()
  											.sort(function(a, b) {   return +a.ACCOUNTNUMBER - +b.ACCOUNTNUMBER; }).map((item, index) => {
											if(item.STATUS !== "A") return null;
											// Check if user is admin of this account or not, need to check localUserDetails service response for this
											let isAdmin = false;
											if(localUserDetails && localUserDetails.responseObject && localUserDetails.responseObject.accounts) {
												const result = _.find(localUserDetails.responseObject.accounts, ['accountNumber', item.ACCOUNTNUMBER]);
												isAdmin = result && result.admin === "Y" ? true : false;
											}
											return <tr key={index}>
												<td>{item.ACCOUNTNUMBER}</td>
												<td>&nbsp;—&nbsp;</td>
											 	<td>{item.ACCOUNTDESCRIPTION} {isAdmin ? <span className="orange">(Account Administrator)</span> : null}</td>
											</tr>
										})}
									</tbody>
								</table>
			          		</div>
							{isDpmCustomerWithPrepayment && updatePhoneNumberNode}
							<div className="largePush">
								<p>To request additional accounts, enter the account number(s) you need access to on GE Appliances CustomerNet.</p>
								<p>You may request access to 20 different accounts. If you need access to more accounts, you will need to contact your Account Administrator.</p>
								<form onSubmit={this.handleUpdateAccounts.bind(this)} className={"requestAccessToCustomerNetForm "+(!this.state.showAddMoreAccountsLink?"withAdditionalAccountNumberFields":"")} name="requestAccessToCustomerNetForm" id="requestAccessToCustomerNetForm">
									<AccountNumberContainers acceptNumbersOnly={this.props.acceptNumbersOnly} handleAddMoreAccounts={this.handleAddMoreAccounts.bind(this)} showAddMoreAccountsLink={this.state.showAddMoreAccountsLink} />
									<p><input type="submit" className="blueButton" value="Update Accounts" /></p>
								</form>
							</div>
			        	</div>
				        {!this.props.isPartsSalesAgreementsOnlyAccount && <div className={`column noInnerTopMargin${!isThisAccountRestricted ? " strokeLeft" : ""}`}>
							{!isThisAccountRestricted && <div>
					          	<h2>Notification Preferences</h2>
					          	<p>View or change notification types tied to an account by selecting that account below.</p>
								<p className="bold red">{this.state.preferencesErrorMessage}</p>
					          	<form onSubmit={this.handleUpdateNotifications.bind(this)} className="updateNotificationPreferencesForm" name="updateNotificationPreferencesForm" id="updateNotificationPreferencesForm">
					            	<table className="notificationPreferencesTable checkboxTable fullWidth">
					              		<thead>
					                		<tr>
					                  			<th>Notification Type</th>
					                  			<th className="checkboxCell">
													{_.filter(this.props.state.user.notificationTypeList, ['checked', true]).length !== this.props.state.user.notificationTypeList.length
														?<a href="" onClick={this.handleSelectAllNotification.bind(this, true)} className="selectAllCheckboxesLink">Select All</a>
														:<a href="" onClick={this.handleSelectAllNotification.bind(this, false)} className="selectAllCheckboxesLink">Deselect All</a>
													}
												</th>
				                			</tr>
					              		</thead>
					              		<tbody>
											{this.props.state.user.notificationTypeList.map((item, index)=> {
												if(typeOfAccount === 'RETAIL') {
													if(item.label === 'Pricing' && !(isPricingAccess && isPriceDiscountAccess)) return null;
													if(item.label === 'Order Acknowledgement' && (
														(isPricingAccess && isPriceDiscountAccess) || isCreateOrderAccess || isEditOrderAccess
													)) {
														item.shortValue = 'ORDER ACKNOWLEDGEMENT W PRICE';
													}
													if(item.label === 'Order Acknowledgement' && !isPricingAccess && !isPriceDiscountAccess && isViewOrderAccess) {
														item.shortValue = 'ORDER ACKNOWLEDGEMENT WO PRICE';
													}
												} else if(typeOfAccount === "CONTRACT" || typeOfAccount === "PRO CHANNEL" || typeOfAccount === "HQ") {
													if(item.label === 'Pricing' && !isPricingAccess) return null;
													if(item.label === 'Order Acknowledgement' && (isPricingAccess || isCreateOrderAccess || isEditOrderAccess)) {
														item.shortValue = 'ORDER ACKNOWLEDGEMENT W PRICE';
													}
													if(item.label === 'Order Acknowledgement' && !isPricingAccess && isViewOrderAccess) {
														item.shortValue = 'ORDER ACKNOWLEDGEMENT WO PRICE';
													}
												}
												return <tr key={index}>
							                  		<td>{item.label}</td>
							                  		<td className="checkboxCell" style={{width:'27%'}}>
														<input type="checkbox" checked={item.checked} onChange={this.handleChangeNotificationType.bind(this)} name="notificationType" value={item.value} />
							                  		</td>
						                		</tr>
											})}
					              		</tbody>
					            	</table>
									<p><input className="blueButton" type="submit" value="Update Preferences" /></p>
					          	</form>
							</div>}
			        	</div>}
		      		</div>
	  			:null}
				{userDetails && userDetails.typeOfUser === "employee"?
					<div className="columns twoColumns">
						<div className="column strokeRight noInnerTopMargin">
							<div className="largePush">
								<p>
									<strong>User Name:</strong> {userDetails.sso}<br />
									<strong>Email:</strong> {userDetails.email}
								</p>
							</div>
						</div>
					</div>
					:null
				}
				{this.state.showUpdatePhoneNumberOverlayDialog?<PhoneNumberUpdatedOverlayDialog message={this.state.phoneNumberErrorMessage} showDialog={true} />:null}
				{this.state.showUpdatePreferencesOverlayDialog?<UpdateCompleteForNotificationsOverlayDialog message={this.state.preferencesErrorMessage} showDialog={true} />:null}
				{this.state.showUpdateAccountsOverlayDialog?<UpdateCompleteForAccountAccessRequestOverlayDialog message={this.state.accountsErrorMessage} showDialog={true} />:null}
			</div>
        );
    }
}
const mapStateToProps = (state) => {
    return {state};
};

const mapDispatchToProps = (dispatch) => ({
	updateNotification: (data) => dispatch(updateNotification(data)),
	selectAllNotificationList: (data) => dispatch(selectAllNotificationList(data)),
	saveIsAnyValidAccountNumber: (data) => dispatch(saveIsAnyValidAccountNumber(data)),
	changePhoneNumber: (queryStringParams, callback) => dispatch(changePhoneNumber(queryStringParams, callback)),
	updateUserAccounts: (payload, hybridQueryParams, callback) => dispatch(updateUserAccounts(payload, hybridQueryParams, callback)),
	resetGEAccountNumbers: () => dispatch(resetGEAccountNumbers()),
	saveUserProfile: (data) => dispatch(saveUserProfile(data)),
	sendEmailSuccessDialog: (data) => dispatch(sendEmailSuccessDialog(data)),
	getAdminEmailAddress: (data, callback) => dispatch(getAdminEmailAddress(data, callback)),
	dropProductSpecsEmail: (payload, hybridQueryParams, callback) => dispatch(dropProductSpecsEmail(payload, hybridQueryParams, callback)),
	getUserContactPointList: (data, callback) => dispatch(getUserContactPointList(data, callback)),
	saveUserContactPointList: (data) => dispatch(saveUserContactPointList(data)),
	backupNotificationList: () => dispatch(backupNotificationList()),
	saveRoleList: (data) => dispatch(saveRoleList(data)),
	updateUserNotifications: (payload, hybridQueryParams, callback) => dispatch(updateUserNotifications(payload, hybridQueryParams, callback)),
	getRoleList: (payload, callback) => dispatch(getRoleList(payload, callback)),
});

MyProfile = connect(mapStateToProps, mapDispatchToProps)(MyProfile);
export default MyProfile;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Profile/MyProfile.js